
























































































































































import {
	defineComponent,
	PropType,
	computed,
	ref,
	watch,
} from '@vue/composition-api';
import { v } from '@front-app/components/form/validation/useValidation';
import isAfter from 'date-fns/isAfter/index';
import isBefore from 'date-fns/isBefore/index';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { afterDate } from '@front-app/components/form/validation/validators';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import YearMonthDayInput from '@front-app/components/inputs/YearMonthDayInput.vue';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import DropdownDivider from '@front-app/components/dropdowns/DropdownDivider.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import { LearningProgram } from '../Model';

const convertToDate = (dateStr: string | null): Date | null => (dateStr ? new Date(dateStr) : null);

export default defineComponent({
	components: {
		SimpleDropdown,
		CtaButton,
		TrForm,
		FormSection,
		FormLabel,
		FormError,
		YearMonthDayInput,
		XButton,
		DropdownDivider,
		LoaderState,
		HelpTooltipBlock,
	},
	props: {
		startDate: {
			type: String as PropType<string | null>,
			default: null,
		},
		endDate: {
			type: String as PropType<string | null>,
			default: null,
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_RIGHT,
		},
		isLoading: Boolean,
		hideEndDate: Boolean,
		required: Boolean,
	},
	setup(props, ctx) {
		const isPublishMenuOpen = ref(false);
		const localStartDate = ref(convertToDate(props.startDate));
		const localEndDate = ref(convertToDate(props.endDate));

		const validation = v({
			endDateAfterStart: {
				value: localEndDate,
				rules: [afterDate(localStartDate)],
			},
			endDateWithoutStart: {
				value: localEndDate,
				rules: [
					{
						validator: () => !(localEndDate.value && !localStartDate.value),
					},
				],
			},
		});

		watch(isPublishMenuOpen, (isOpen) => {
			if (!isOpen) {
				return;
			}
			localStartDate.value = convertToDate(props.startDate);
			localEndDate.value = convertToDate(props.endDate);
		});
		const isPublished = computed(() => {
			if (!props.startDate) {
				return false;
			}
			const now = new Date();
			return isBefore(new Date(props.startDate), now) && (!props.endDate || isAfter(new Date(props.endDate), now));
		});
		const clearStartDate = () => {
			localStartDate.value = null;
			localEndDate.value = null;
		};
		const clearEndDate = () => {
			localEndDate.value = null;
		};
		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.date-picker-form' });
		const submitForm = () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			const payload: Partial<LearningProgram> = {
				publishDateStart: localStartDate.value?.toISOString() || null,
				publishDateEnd: localEndDate.value?.toISOString() || null,
			};
			ctx.emit('input', payload);
			isPublishMenuOpen.value = false;
		};

		const publishNow = () => {
			const now = new Date();
			localStartDate.value = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
			localEndDate.value = null;
			submitForm();
		};
		const unpublish = () => {
			clearStartDate();
			submitForm();
		};
		return {
			isPublished,
			isPublishMenuOpen,
			clearStartDate,
			localStartDate,
			clearEndDate,
			localEndDate,
			publishNow,
			unpublish,
			submitForm,
			validation,
			updatingLoaderSize: Size.SMALL,
			dropdownTriggerSize: Size.INLINE,
			publishNowButtonPalette: ButtonPalettes.SUCCESS,
			saveButtonPalette: ButtonPalettes.PRIMARY,
			dropdownTriggerPalette: ButtonPalettes.PRIMARY,
		};
	},
});
